<div class="row">
<div class="col-sm-4">
<app-side-bar-guardian-home [guardian]="guardian" *ngIf="guardian"></app-side-bar-guardian-home>
</div>
<div class="col-sm-8">
   <div class="alert alert-info" *ngIf="status!=''"> {{status}}</div>
   <form  [formGroup]="searchTemplateForm" *ngIf="server_guardian_id!=0" >
      <div class="row mt-5">
                <div class="col-sm-4" > Search Profile</div>
                <div class="col-sm-4" >
                    <input   formControlName="searchInput" class="form-control"/>
                </div>
      </div>
   </form>
      <ul>
            <li *ngFor="let profile of profileList;" style="list-style: none;">
               <button (click)="addStudent(profile.id)" class="mt-1 btn btn-primary"> Add Student</button> {{profile.text}}
            </li>

      </ul>
      </div>
   </div>







